const legacyCopy = {
  "Hola Fresh Exports, quiero información sobre disponibilidad y catálogo de flores.": "Hello Fresh Exports, I would like information about flower availability and your catalog.",
  "Hola Fresh Exports, quiero información sobre su catálogo de flores.": "Hello Fresh Exports, I would like information about your flower catalog.",
  "Hola Fresh Exports, quiero recibir información sobre disponibilidad, variedades y exportación de flores.": "Hello Fresh Exports, I would like information about flower availability, varieties and export options.",
  "En Fresh Exports trabajamos con flores frescas, elegantes y cuidadosamente seleccionadas para clientes que buscan calidad, presentación y confianza comercial.": "At Fresh Exports, we offer fresh, elegant and carefully selected flowers for customers who value quality, presentation and a trusted business partner.",
  "Nuestro equipo puede ayudarte con disponibilidad, variedades, colores, empaque y opciones de exportación. Escríbenos y coordinamos tu pedido con atención personalizada.": "Our team can help with availability, varieties, colors, packaging and export options. Contact us for personal assistance with your order.",
  "No pudimos confirmar el envío. Inténtalo de nuevo en unos minutos.": "We could not confirm delivery. Please try again in a few minutes.",
  "No pudimos enviar tu mensaje. Inténtalo de nuevo en unos minutos.": "We could not send your message. Please try again in a few minutes.",
  "Has enviado varios mensajes. Inténtalo de nuevo en unos minutos.": "You have sent several messages. Please try again in a few minutes.",
  "Mensaje enviado. Te responderemos a tu correo electrónico.": "Message sent. We will reply to your e-mail.",
  "Uno de los campos supera la longitud permitida.": "One of the fields exceeds the maximum length.",
  "Ingresa tu nombre, un correo válido y tu mensaje.": "Please enter your name, a valid e-mail and your message.",
  "Revisa los campos del formulario.": "Please check the form fields.",
  "No se pudo enviar el formulario.": "The form could not be submitted.",
  "Descubre nuestras variedades y encuentra la flor ideal para tu próximo pedido.": "Discover our varieties and find the perfect flowers for your next order.",
  "Prueba con otra categoría o cambia el texto de búsqueda.": "Try another category or change your search.",
  "Pronto encontrarás aquí nuestras categorías.": "Our flower categories will be available here soon.",
  "Producto floral disponible para consulta.": "Contact us for details about this flower variety.",
  "Producto floral disponible.": "Flower variety available.",
  "No hay productos disponibles.": "No products available.",
  "Te responderemos a tu correo electrónico.": "We will reply to your e-mail.",
  "De Ecuador, para el mundo.": "From Ecuador to the world.",
  "Hablemos sobre tus flores.": "Let’s talk about your flowers.",
  "EXPLORA NUESTRAS CATEGORÍAS": "EXPLORE OUR CATEGORIES",
  "Seguir viendo catálogo": "Continue browsing",
  "Volver al catálogo": "Back to catalog",
  "Detalle del producto": "Product details",
  "Producto no encontrado": "Product not found",
  "Empresa (opcional)": "Company (optional)",
  "Correo electrónico": "E-mail",
  "Cerrar Quiénes somos": "Close About us",
  "Cerrar Contáctanos": "Close Contact us",
  "Selección de calidad": "Selected for quality",
  "Cuidado en cada envío": "Care in every shipment",
  "Selección premium": "Premium selection",
  "Frescura garantizada": "Guaranteed freshness",
  "Envíos internacionales": "Worldwide shipping",
  "Explorar variedades": "Explore varieties",
  "Escribir por WhatsApp": "Chat on WhatsApp",
  "Buscar variedad…": "Search varieties…",
  "Buscar variedad": "Search varieties",
  "Enviar mensaje": "Send message",
  "Enviando…": "Sending…",
  "Ver catálogo": "View catalog",
  "Ver detalle": "View details",
  "Consultar precio": "Request pricing",
  "Configura tu número de WhatsApp": "WhatsApp unavailable",
  "Configura tu teléfono público": "Phone unavailable",
  "Configura tu correo comercial": "E-mail unavailable",
  "Configura tu dirección": "Address unavailable",
  "Escribir ahora": "Chat now",
  "Enviar email": "Send e-mail",
  "Ver ubicación": "View location",
  "Navegación": "Navigation",
  "Quiénes somos": "About us",
  "Contáctanos": "Contact us",
  "Contacto": "Contact",
  "CONTACTO": "CONTACT",
  "Catálogo": "Catalog",
  "Inicio": "Home",
  "Sistema": "Staff login",
  "Teléfono": "Phone",
  "Ubicación": "Location",
  "Dirección": "Address",
  "Sitio web": "Website",
  "Slide anterior": "Previous slide",
  "Siguiente slide": "Next slide",
  "Ir al slide": "Go to slide",
  "Miniatura": "Thumbnail"
};

export function englishPublicText(value) {
  return typeof value === 'string' ? (legacyCopy[value.trim()] || value) : value;
}

export function englishPublicConfig(config = {}) {
  return Object.fromEntries(Object.entries(config).map(([key, value]) => [key, englishPublicText(value)]));
}
